/**
 * The route pattern on its own, with no nominee data attached.
 *
 * `App.tsx` must import from here rather than from `registry.ts`: importing the registry would
 * pull every nominee config into the client bundle, publishing all 40 names, firms, LinkedIn
 * URLs and private slugs in a file served on every page of the public site.
 */
export const nominationRoutePattern = '/nominated/:nominationSlug'
